import { memo, type ButtonHTMLAttributes } from 'react';
import type { SvgIconComponent } from '@mui/icons-material';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

import { Loader } from './Loader';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'submit' | 'reset' | 'button';
  children?: React.ReactNode;
  isSecondary?: boolean;
  isDisabled?: boolean;
  className?: string;
  icon?: SvgIconComponent;
  iconClassName?: string;
  notices?: number;
  loading?: boolean;
}

export const Button = memo(
  ({
    type = 'button',
    children = 'Button',
    isSecondary = false,
    isDisabled = false,
    className = '',
    iconClassName = '',
    icon: Icon,
    notices,
    loading,
    ...rest
  }: Props) => (
    <button
      className={twMerge(
        clsx(
          'w-full text-base h-max py-2 rounded-md border-1 focus:outline-none font-bold focus:ring-2 transition-all focus:border-transparent hover:shadow-md flex justify-center gap-2 items-center',
          {
            'bg-secondary text-black border-transparent': isSecondary,
            'bg-primary text-primary border-primary': !isSecondary,
            'bg-gray-300 text-gray-700 cursor-not-allowed hover:shadow-none': loading || isDisabled,
          },
          className
        )
      )}
      {...rest}
      type={type}
      disabled={loading || isDisabled}>
      {Icon && (
        <div className={iconClassName ?? ''}>
          <Icon />
        </div>
      )}

      {loading ? <Loader classname="flex items-center justify-center" size={25} /> : children}
      {notices && (
        <div className="flex items-center justify-center text-sm font-bold rounded-full bg-secondary-light text-primary-dark size-6">{notices}</div>
      )}
    </button>
  )
);
